// ============================================================================
// vpn/uiClasses.ts — единые классы полей VPN-форм (SSoT, без дублей строк).
// ============================================================================

export const VPN_INPUT_CLS = 'h-8 w-full rounded-md border bg-background px-2 text-sm';
export const VPN_LABEL_CLS = 'text-xs text-muted-foreground';
